import { createContext, ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

/*
 * Where page-level actions (Export and the like) render: beside the title in
 * the layout's page head, not inside the page body.
 *
 * `undefined` means there is no layout around the page, as in a test, so the
 * actions render in place. `null` means the layout is there but its slot has
 * not mounted yet, so they wait a commit for it.
 */
export const PageActionsContext = createContext<HTMLElement | null | undefined>(
  undefined
);

export default function PageActions({ children }: { children: ReactNode }) {
  const target = useContext(PageActionsContext);

  if (target === undefined) return <>{children}</>;
  if (target === null) return null;

  return createPortal(children, target);
}
